<template>
    <div slot="content">
         
        <!-- 캠페인 합계 s.-->
        <div class="table-area">
            <div class="table-a">
                <el-table
                    :data="campaignSumList"
                    style="width: 100%;">
                    <el-table-column prop="campaignNm" label="캠페인명" align="center" width="260"> </el-table-column>
                    <el-table-column prop="totalCnt" label="총건수" align="center" width="215"> </el-table-column>
                    <el-table-column prop="devideCnt" label="할당건수" align="center" width="215"> </el-table-column>
                    <el-table-column prop="nondevideCnt" label="미할당건수" align="center" width="215"> </el-table-column>
                    <el-table-column prop="doneCnt" label="완료건수" align="center" width="215"> </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 캠페인 합계 e.-->

        <!-- 검색폼 s-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `대상자 조회` }}</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix">
                        <button class="btn-size btn-gray fl_left" @click="goBack">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        뒤로가기
                        </button>

                        <button v-if="showTarget" class="btn-size btn-gray fl_left" @click="saveTarget">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        대상자생성하기
                        </button>
                        
                        <button v-if="showDelete" class="btn-size btn-gray fl_left" @click="deleteCust">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        삭제
                        </button>
                    
                        <button v-if="showSelect" class="btn-size btn-gray fl_left" @click="searchCust">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        조회
                        </button>
                
                        <button class="btn-size btn-gray fl_left" @click="excelDown">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        엑셀
                        </button>
                    </div>
                </div>
                <el-form ref="form" :model="form" label-width="60px" size="mini">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="고객명">
                                <el-input v-model.trim="search.custNm" @keyup.native.enter="searchCust"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="전화번호" label-width="70px">
                                <el-input v-model.trim="search.telNo" @keyup.native.enter="searchCust"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="상담원">
                                <el-col>
                                    <el-input v-model.trim="search.userNm" @keyup.native.enter="searchCust"></el-input>
                                </el-col>
                            </el-form-item>
                        </el-col>
                        <el-col :span="9">
                            <el-form-item label="상태">
                                <el-row>
                                    <el-col :span="8">
                                        <el-select v-model="search.campaignCustStatus" @change="onSearhStatus1">
                                            <el-option value='' label="전체">전체</el-option>
                                            <el-option
                                                v-for="item in combos['campaignCustStatus']"
                                                :key="item.value"
                                                :value="item.key"
                                                :label="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-select v-model="search.campaignCustStatus2" @change="onSearhStatus2" v-show="search.showSearchStatus2">
                                            <el-option value='' label="선택">선택</el-option>
                                            <el-option
                                                v-for="item in combos['campaignCustStatus2']"
                                                :key="item.value"
                                                :value="item.key"
                                                :label="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-select v-model="search.campaignCustStatus3" v-show="search.showSearchStatus3">
                                            <el-option value='' label="선택">선택</el-option>
                                            <el-option
                                                v-for="item in combos['campaignCustStatus3']"
                                                :key="item.value"
                                                :value="item.key"
                                                :label="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- 검색폼 e -->

        <!-- 기사정보2 그리드 s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="subGrid" 
                            :style="subGridStyle"
                            class="ag-theme-alpine"
                            row-selection="single"
                            :column-defs="subColumnDefs"
                            :grid-options="subGridOptions"
                            :row-data="subData"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReadySub"
                            :statusBar="statusBar" />
                    </div>
                </div>
            </div>
        </div>
        <!-- 기사정보2 그리드 e.-->

        <div class="grid-tbl-box" v-show="false">
            <ag-grid-vue 
                ref="excelGrid" 
                :style="gridStyle"
                class="ag-theme-alpine"
                row-selection="single"
                :column-defs="excelColumnDefs"
                :grid-options="excelGridOptions"
                :row-data="excelData"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                @grid-ready="onReadyExcel"
                />
        </div>
    </div>
</template>


<script>
/**
 * * mixins
 */
import slip from '@/mixin/slip';
import common from '@/mixin/common';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';

/**
 * * Modal
 */
 import HappycallCustTargettingModal from '@/components/AS/HappycallMng/HappycallCustTargettingModal.vue';

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

/**
 * 객체내의 값 초기화
 */
 $.ObjectInitialize = function (obj) {
    let self = this;
    self.obj = obj;

    $.each(obj, function (item_name, item) {
        let datatype = $.type(item);

        if (datatype == "number")
            self.obj[item_name] = 0;   // 정수는 0 으로 초기화

        else if (datatype == "string")
            self.obj[item_name] = '';   // 문자는 '' 으로 초기화

        else if (datatype == "boolean")
            self.obj[item_name] = false;   // boolean 는 false 으로 초기화

        else if (datatype == "array")
            self.obj[item_name] = [];   // 배열은 [] 으로 초기화

        else if (datatype == "object")
            self.obj[item_name] = {};   // object는  {} 으로 초기화

    });
} 

export default {
    mixins: [slip, common],
    components: {AgGridVue, DhxCalendar},
    props: ['custParam'],
    data() {
        return {
            form: {
                userCd: '', /** ID */
                groupNm: '', /** 그룹구분 */
                positionCd: '', /** 직급 */
                userNm: '', /** 성명 */
                carNo: '', /** 차량번호 */
                enterDt: '', /** 입사일자 */
                area: '', /** 담당지역 */
                hpNo: '', /** 휴대폰 */
                weekMorning: '', /** 평일오전 */
                weekAfternoon: '', /** 평일 오후 */
                weekendMorning: '', /** 주말오전 */
                weekendAfternoon: '' /** 주말 오후 */
            },
            search: {
                custNm: '',
                telNo: '',
                userNm: '',
                campaignCustStatus: '',
                campaignCustStatus2: '',
                campaignCustStatus3: '',
                showSearchStatus2: false,
                showSearchStatus3: false
            },
            combos: {
                'campaignCustStatus': [],
                'campaignCustStatus2': [],
                'campaignCustStatus3': [],
                'stisfactionType' : [],
                'allCampaignCustStatus': []
            },
            campaignSumList: [
                {
                    campaignNm: '',
                    totalCnt: '',
                    devideCnt: '',
                    nondevideCnt: '',
                    doneCnt: ''
                }
            ], /** 총건수, 할당건수, 미할당건수, 완료건수 */
            showSelect: false,
            showTarget: false,
            showDelete: false,
            campaignStatus: '',
            data: [],
            subData: [{
                userCd: '', /** ID */
                groupNm: '', /** 그룹구분 */
                positionCd: '', /** 직급 */
                userNm: '', /** 성명 */
                carNo: '', /** 차량번호 */
                enterDt: '', /** 입사일자 */
                area: '', /** 담당지역 */
                hpNo: '', /** 휴대폰 */
                weekMorning: '', /** 평일오전 */
                weekAfternoon: '', /** 평일 오후 */
                weekendMorning: '', /** 주말오전 */
                weekendAfternoon: '' /** 주말 오후 */
            }],
            excelData: [],
            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 40px; width: 100%;height: 400px; min-height:100px;',
            subGridStyle : 'padding-top: 0px; width: 100%;height: 600px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter:false
                , sortable: true
            },
            subColumnDefs: [],
            subGridApi: null,
            subColumnApi: null,
            subGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            excelGridApi: null,
            excelColumnApi: null,
            excelGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            excelColumnDefs: [],
            frameworkComponent : {
                'checkBox': CheckboxCellRenderer,
            },
            statusBar: null,
            //AG-GRID OPTION [END]
        }
    },
    computed: {
        
    },
    created() {
        this.statusBar = {
            statusPanels: [
                { statusPanel: 'agTotalRowCountComponent', align: 'right' },
            ],
        };
    },
    mounted() {
        
        if(this.$route.params.detailLinkYn==='Y'){
            // 상세페이지 클릭하여 페이지이동한 경우

            if(this.$route.params.campaignId===''){
                // campaignId 를 체크
                this.$swal({ type: 'warning', text: '해당 캠페인은 삭제된 캠페인입니다.' })
                return false;

            } else {
                this.init();
            }
        }
    },
    methods: {
        onReadySub() {
            this.subGridApi = this.subGridOptions.api;
            this.subColumnApi = this.subGridOptions.columnApi;
            this.createSubColumnDefs();
            this.createExcelColumnDefs();
        },
        createSubColumnDefs() {
            const vm = this;
            this.subColumnDefs=[
                {
                    headerName:'선택',
                    field:'chk', 
                    width:80,
                    cellStyle : {textAlign: 'center'},
                    cellRenderer: 'checkBox',
                    cellRendererParams: (params) => {
                        return {
                            trueValue: 'Y',
                            falseValue: 'N',
                            disable: params.data.campaignCustStatus==='Ready' ? false : true
                        }
                    }
                },
                {
                    headerName:'AS접수번호', 
                    field:'asId', 
                    width:140,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'고객명', 
                    field:'boundCustNm', 
                    width:200,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'전화/발신자번호', 
                    field:'boundTelNo', 
                    width:200,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName: '핸드폰번호', 
                    field:'asTelNo', 
                    width: 200,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '상담원', 
                    field:'userNm', 
                    width: 200,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '상태', 
                    field:'campaignCustStatusNm', 
                    width: 200,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '상태', 
                    field:'campaignCustStatus', 
                    width: 200,
                    hide: true,
                    cellStyle:{textAlign:'center'}
                }
            ]
        },
        onSubCellClicked(params) {
            //const idx = params.rowIndex;
            console.log('onSubCellClicked : ', params)
        },
        createExcelColumnDefs() {
            const vm = this;
            this.excelColumnDefs = [
                {
                    headerName:'순번',
                    field:'no',
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    valueFormatter: function(params) {
                        return params.node.rowIndex+1;
                    }
                },
                {headerName:'처리센터', field:'allocationAsAgentNm', width:120, cellStyle:{textAlign: 'center'}},
                {headerName:'처리기사', field:'allocationRepairNm', width:120, cellStyle:{textAlign: 'center'}},
                {headerName:'AS접수번호', field:'asId', width:110, cellStyle:{textAlign: 'center'}},
                {headerName:'고객명', field:'boundCustNm', width:120, cellStyle:{textAlign: 'center'}},
                {headerName:'전화/발신번호', field:'telNo', width:100, cellStyle:{textAlign: 'left'}},
                {headerName:'핸드폰번호', field:'hpNo', width:100, cellStyle:{textAlign: 'left'}},
                {headerName:'상담원', field:'userNm', width:120, cellStyle:{textAlign: 'center'}},
                {headerName:'해피콜상태', field:'campaignCustStatusNm', width:100, cellStyle:{textAlign: 'left'}},
                {headerName:'만족도', field:'stisfactionTypeNm', width:120, cellStyle:{textAlign: 'right'}},
                {headerName:'제조사', field:'makerNm', width:120, cellStyle:{textAlign: 'right'}},
                {headerName:'제품군', field:'modelGroupNm', width:120, cellStyle:{textAlign: 'right'}},
                {headerName:'대표모델', field:'standardModelNm', width:120, cellStyle:{textAlign: 'right'}},
                {headerName:'모델', field:'modelNm', width:120, cellStyle:{textAlign: 'center'}, hide: true},
                {headerName:'사유', field:'description', width:220, cellStyle:{textAlign: 'center'}}
            ];
        },
        onReadyExcel() {
            this.excelGridApi = this.excelGridOptions.api;
            this.excelColumnApi = this.excelGridOptions.columnApi;
        },
        async init() {
            this.isAuth();
            
            // 만족도
            await this.$http.get(`/api/asMng/call/topkey`, {params: {topKey: 'StisfactionType'}})
                .then(response => {
                    this.combos['stisfactionType'] = response.data || [];
                }); 

            // 처리결과 : CampaignCustStatus
            await this.$http.get(`/api/asMng/call/topkey`, {params: {topKey: 'CampaignCustStatus'}})
                .then(response => {
                    this.combos['allCampaignCustStatus'] = response.data || [];
                    this.combos['allCampaignCustStatus'] = this.combos['allCampaignCustStatus'].filter(x=>x.deleteYn==='N')
                        .map(y=>{y.key=y.catKey; y.value=y.catNm; return y;});

                    // 상태 : 캠페인대상진행상태
                    this.combos['campaignCustStatus'] = _.cloneDeep(this.combos['allCampaignCustStatus'].filter(x=>x.catLvl==2));
          
                    this.searchCust();
                }); 
        },
        goBack(){
            // 리스트 조회화면으로 이동
            this.$router.push({          
                name: 'HappyCallManager',
                params: {
                    searchCond: {
                        ...this.$route.params
                    }
                }
            });
        },
        saveTarget(){
            // 대상자생성하기
            const vCampaignId = this.$route.params.campaignId;
            if(!vCampaignId){
                // campaignId 를 체크
                this.$swal({ type: 'warning', text: '해당 캠페인은 삭제된 캠페인입니다.' })
                return false;
            }

            let vm = this;
            this.$modal.open({
                width: 1200,
                component: HappycallCustTargettingModal,
                parent: this,
                props: {
                    data: {
                        campaignId: vCampaignId
                    },
                },
                events: {
                    close(data) {
                        console.log('close', data);
                        vm.searchCust();
                    },
                }
            });
        },
        deleteCust(){
            // 대상자 삭제

            const vm = this;
            const vChkSubData = this.subData.filter(x=>x.chk==='Y');
            const vDistObj = this.subData.filter(x=>x.campaignCustStatus==='Distribution');

            if(this.campaignStatus==='Complete'){
                this.$swal({ type: 'warning', text: '캠페인 완료 상태이어서 삭제할 할수가 없습니다.' })
                return false;
            } else if(this.subData && vDistObj && vDistObj.length === this.subData.length){
                this.$swal({ type: 'warning', text: '할당된 상태에서는 삭제할 수가 없습니다.' })
                return false;
            }

            if(vChkSubData.length === 0){
                this.$swal({ type: 'warning', text: '삭제할 대상자를 체크하세요.' })
                return false;
            } 

           
            this.$swal({
                type: 'warning',
                text: `선택한 대상자를 삭제하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    
                    const vCampaignCustIds = [];
                    vChkSubData.map(x=>{
                        vCampaignCustIds.push(x.campaignCustId);
                        return x;
                    });
                    
                    const vform = {
                        campaignCustIds: vCampaignCustIds,
                        campaignId: this.$route.params.campaignId
                    }
                    
                    console.log('save ...vform: ', vform)             
                    vm.$store.commit('loading')
                    vm.$http.put(_url("/api/workMng/happyCallManager/deleteCampaignCust"), vform)
                        .then(response => {
                            vm.searchCust();
                            vm.$swal({ type: 'success', text: response.data });
                            
                        }).catch((e) => {
                            // console.error(e);
                            // vm.$swal({ type: 'success', text: '처리결과 저장에 실패했습니다' })
                        })
                        .finally(() => {
                            vm.$store.commit('finish');
                        });
                }
            });

        },
        searchCust(){
            /** 대상자 조회 */
            
            let vCampaignCustStatus = this.search.campaignCustStatus3 || '';
            if(vCampaignCustStatus === ''){
                vCampaignCustStatus = this.search.campaignCustStatus2 || '';
            }

            if(vCampaignCustStatus === ''){
                vCampaignCustStatus = this.search.campaignCustStatus || '';
            }
            
            const vform = {
                campaignId: this.$route.params.campaignId,
                custNm: this.search.custNm || '',
                telNo: this.search.telNo || '',
                userNm: this.search.userNm || '',
                campaignCustStatus: vCampaignCustStatus,
                sortType: '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }
            
            this.$store.commit('loading')
            console.log('searchCust vform : ', vform) 
            this.$http.post(("/api/workMng/happyCallManager/selectCust"), vform
                ).then(response => {
                 console.log('searchCust response.data' , response.data)

                 const vFormObj = 
                    response.data.uspCampaignSelItem.map(x=>{
                        if(x.startDt && x.startDt.length >= 10){
                            x.startDt = x.startDt.substring(0,10); 
                        }
                        if(x.endDt && x.endDt.length >= 10){
                            x.endDt = x.endDt.substring(0,10); 
                        }

                        return x;
                    });

                this.campaignStatus = '';
                if(vFormObj && vFormObj.length>0){
                    this.campaignSumList  = 
                        [
                            {
                                campaignNm: vFormObj[0].campaignNm, 
                                totalCnt: vFormObj[0].totalCnt,
                                devideCnt: vFormObj[0].devideCnt,
                                nondevideCnt: vFormObj[0].nondevideCnt,
                                doneCnt: vFormObj[0].doneCnt
                            }
                        ];

                    this.form = vFormObj[0] || {};
                    this.campaignStatus = vFormObj[0].campaignStatus || '';
                 }
                 
                 this.subData = response.data.uspCampaignCustSelPage.map(x=>{
                    x.chk = 'N';
                    x.boundTelNo = _phone(x.boundTelNo);
                    x.asTelNo = _phone(x.asTelNo);

                    const vCampaignCustStatusObj = this.combos['allCampaignCustStatus'].filter(y=>y.key===x.campaignCustStatus) 
                    //console.log('vCampaignCustStatusObj : ', x.campaignCustStatus, vCampaignCustStatusObj);
                    if(vCampaignCustStatusObj && vCampaignCustStatusObj.length>0){
                        x.campaignCustStatus = vCampaignCustStatusObj[0].key;
                        x.campaignCustStatusNm = vCampaignCustStatusObj[0].value;
                    }

                    return x;
                 });

                
            }).finally(() => {
                this.$store.commit('finish')

                
            });
        },
        isAuth(){
            const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===101); // 해피콜관리(캠페인대상자)
            this.showSelect = false; // 입력권한
            this.showTarget = false; // 
            this.showDelete = false; // 
            if(auth && auth.length > 0){
                this.showSelect = auth[0].grantSelect === 'Y' ? true : false ;
                this.showTarget = auth[0].grantExtend1 === 'Y' ? true : false ;
                this.showDelete = auth[0].grantDelete === 'Y' ? true : false ;
            }
        },
        async onSearhStatus1(param){
        // 화면중간 처리결과에서 1번째 select박스 변경시

            console.log('onSearhStatus1 change param : ', param)
            if(param === 'Complete'){
                this.search.showSearchStatus2 = true;
                console.log(' onSearhStatus1 change vojb;', this.combos['campaignCustStatus'])
                const vObj = this.combos['campaignCustStatus'].filter(x=>x.catKey===param);
                console.log(' onSearhStatus1 change vojb2;', vObj)
                if(vObj && vObj.length>0){
                this.combos['campaignCustStatus2'] = _.cloneDeep(this.combos['allCampaignCustStatus'].filter(x=>x.catLvl==3));
                this.search.campaignCustStatus2 = '';
                }
                
            } else {
                this.search.campaignCustStatus2 = '';
                this.search.campaignCustStatus3 = '';

                this.search.showSearchStatus2 = false;
                this.search.showSearchStatus3 = false;

                this.combos['campaignCustStatus2'] = [];
                this.combos['campaignCustStatus3'] = [];
            }
        },
        async onSearhStatus2(param){
            // 화면중간 처리결과에서 2번째 select박스 변경시

            this.search.showSearchStatus3 = true;
            const vObj = this.combos['campaignCustStatus2'].filter(x=>x.key===param);
            
            if(vObj && vObj.length>0){
                this.combos['campaignCustStatus3'] = _.cloneDeep(this.combos['allCampaignCustStatus'].filter(x=>x.catLvl==4 && x.parentId==vObj[0].catId));
                this.search.campaignCustStatus3 = '';
                if(this.combos['campaignCustStatus3'].length ===0 ) {
                this.search.showSearchStatus3 = false;
                this.combos['campaignCustStatus3'] = [];  
                }
            } else {
                this.search.showSearchStatus3 = false;
                this.search.campaignCustStatus3 = '';
                this.combos['campaignCustStatus3'] = [];
            }
        
        },    
        excelDown(){
            this.$store.commit('loading')

            let vStartDt = this.search.startDt ? this.search.startDt.replace(/[^0-9]/g, '') : '';
            let vEndDt = this.search.endDt ? this.search.endDt.replace(/[^0-9]/g, '') : '';

            const vform = {
                ...this.search,
                campaignId : this.$route.params.campaignId,
                sortType: ''
            }

            console.log('excelDown pass vform: ', vform);
            this.search.deliveryNoCount = 0; //초기화
            this.$http.post(_url("/api/asMng/happyCallList/selectCampaignCustSel"), vform).then(response => {
                console.log('excelDown response.data' , response.data)
                this.excelData = response.data.map((x, index)=>{
                x.no = index + 1;
                
                const vStisfactionTypeObj = this.combos['stisfactionType'].filter(y=>y.catKey===x.stisfaction);
                x.stisfactionTypeNm = vStisfactionTypeObj && vStisfactionTypeObj.length>0 ? vStisfactionTypeObj[0].catNm : '';
                
                const vCampaignCustStatusObj = this.combos['allCampaignCustStatus'].filter(y=>y.catKey===x.campaignCustStatus);
                x.campaignCustStatusNm = vCampaignCustStatusObj && vCampaignCustStatusObj.length>0 ? vCampaignCustStatusObj[0].catNm : '';
                
                x.telNo = _phone(x.telNo);
                x.hpNo = _phone(x.hpNo);
                
                return x;
                }); 

            }).finally(() => {
                this.$store.commit('finish');

                var params = {
                fileName : "캠페인대상자"
                };
                this.excelGridOptions.api.exportDataAsExcel(params);

            });
        
        }
        
    }
}
</script>

<style scoped>
.el-form {
    border: 1px solid #c7c7c7;
    padding: 10px;
    border-radius: 5px;
}
</style>